"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let size = 0;
const map = new WeakMap();
function singleton(value) {
    if (!map.has(value)) {
        map.set(value, size++);
    }
    return map.get(value);
}
exports.default = singleton;
